import React, { useEffect, useState, useMemo } from "react";
import { useParams } from "react-router-dom";
import { certificateService } from "../../services/api";
import { styled } from '@mui/material/styles';

import { useNavigate } from 'react-router-dom';
import {
  PlayCircleOutline,
  Description,
  Assignment,
  Quiz,
  MenuBook,
  AccountTree,
  ExpandMore,
  ArrowForward,
  CheckCircle,
  Lock,
  Info,
  Warning,
} from '@mui/icons-material';
import AccessTime from '@mui/icons-material/AccessTime';
import Schedule from '@mui/icons-material/Schedule';
import CalendarToday from '@mui/icons-material/CalendarToday';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import PsychologyIcon from '@mui/icons-material/Psychology'; // Best for general/tech skills
import TipsAndUpdatesIcon from '@mui/icons-material/TipsAndUpdates'; // For soft skills
import { useContentPlayer } from '../../context/ContentPlayerContext';
import { useUser } from '../../context/UserContext';
import { useToast } from '../../context/ToastContext';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Avatar,
  Divider,
  CircularProgress,
  Tooltip,
  IconButton,
  Chip,
  Paper,
  Stack,
  ListItemText,
  List,
  ListItem,
  ListItemIcon,
  AccordionSummary,
  LinearProgress, Button,
  // ArrowForwardIcon
} from "@mui/material";
import '../Course/CoursePreview.css';
import { formatDate } from '../../utils/dateFormatter';
const SectionPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
}));

const ModuleItem = styled(ListItem)(({ theme, completed, isLast, isEnrolledInCurrentInstance }) => ({
  marginBottom: theme.spacing(1),
  backgroundColor: completed && isEnrolledInCurrentInstance ? 'rgba(76, 175, 80, 0.08)' : 'transparent',
  '&:hover': {
    backgroundColor: completed && isEnrolledInCurrentInstance ? 'rgba(76, 175, 80, 0.12)' : 'rgba(0, 0, 0, 0.04)',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
  },
  border: '1px solid #bbb',
  borderRadius: '8px',
  'margin-bottom': '10px',
  cursor: 'pointer',
  
}));


const ContentThumbnail = styled(Box)(({ theme }) => ({
  width: 60,
  height: 60,
  borderRadius: '8px',
  marginRight: theme.spacing(2),
  overflow: 'hidden',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#f0f0f0',
  border: '1px solid #ddd'
}));
const DescriptionContent = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  '& p': {
    marginBottom: theme.spacing(2),
  }
}));
  const getContentIcon = (type) => {
    switch (type?.toLowerCase()) {
      case 'video':
        return <PlayCircleOutline />;
      case 'document':
        return <Description />;
      // case 'assignment':
      //   return <Assignment />;
      // case 'quiz':
      //   return <Quiz />;
      case 'course':
        return <MenuBook color="primary" />;
      case 'learning path':
        return <AccountTree color="success" />;
      default:
        return <Description />;
    }
  };
  const HeaderPaper = styled(Paper)(({ theme }) => ({
    marginBottom: theme.spacing(3),
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
    width: '100%',
  }));
  const ProgressCircle = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'inline-flex',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

const CircleLabel = styled(Box)(({ theme }) => ({
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  position: 'absolute',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
const CertificatePreview = (enrolled = true,refreshOnClose,progress) => {
  const { id } = useParams(); // certificate id
  const [certificate, setCertificate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [skills , setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [courseContents, setCourseContents] = useState({});
  const [expandedCourseId, setExpandedCourseId] = useState(null);
  const [selectedContent, setSelectedContent] = useState(null);
  const [progressMap, setProgressMap] = useState({});
  const [contentProgressMap, setContentProgressMap] = useState({});;
  const [contentStats,setContentStats]=useState([]);
  const [enrolledObj,setEnrolledObj]=useState([]);
  const [courseProgressList,setCourseProgressList] = useState([]);
  const [hasStarted, setHasStarted] = useState(false);
   const { openContentPlayer } = useContentPlayer();
    const { showToast } = useToast();
    

  const navigate = useNavigate();
   const { user } = useUser();
   const learnerId = user?.id;
   const isAdminOrAuthor = user && [1, 11, 5, 7].includes(user.current_role_id);
    const isEnrolledInCurrentInstance = enrolledObj 
   const isLearnerMode = !isAdminOrAuthor;
  useEffect(() => {
    if (id) {
      certificateService
        .getCertificatePreview(id)
        .then((res) => {
          if (res?.data?.success) {
            setCertificate(res.data.certificate);
          //    const certData = {
          //   ...res.data.certificate,
          //   existingEntry:res.data.existingEntry 
          // };
         
          // setCertificate(certData);
            setCourses(res.data.courses);
            setSkills(res.data.skills);
            setCourseContents(res.data.courseContents);
            setContentStats(res.data.contentStats);
            setEnrolledObj(res.data.enrolledObj);
            setCourseProgressList(res.data.courseProgressList);
          }
        })
        .finally(() => setLoading(false));
    }
  }, [id]);

const handleFirstTimeStart = async () => {
  try {
     const res = await certificateService.markCertificateStarted(id);
    setHasStarted(res);
  } catch (error) {
    console.error('Error starting certificate:', error);
  }
};


  if (loading) {
    return (
      <Box display="flex" justifyContent="center" mt={10}>
        <CircularProgress />
      </Box>
    );
  }

  if (!certificate) {
    return (
      <Box textAlign="center" mt={5}>
        <Typography variant="h6" color="error">
          Certificate not found
        </Typography>
      </Box>
    );
  }

const handleCourseToggle = (courseId) => {
  setExpandedCourseId(prev => (prev === courseId ? null : courseId));
};


const isContentCompleted = (courseId, contentId) => {
  const progress = contentProgressMap[`${courseId}-${contentId}`];
  return progress?.completed_items?.includes(contentId?.toString());
};

const handleButtonClick = () => {
  const { buttonText, courses } = courseProgressList;

  if (buttonText === "Start") {
    handleStart(courses[0]);
  }
  else if (buttonText === "Continue") {
    handleStart();
  }
  else if (buttonText === "Revisit") {
     handleStart();
  }
};


const handleStart = async () => {
  try {
    // Find the first incomplete course
    const activeCourse = courses.find((course) => course.progress !== 100);

    if (!activeCourse) {
      showToast('All courses already completed!', 'success');
      return;
    }

    const res = await certificateService.startCertificate(certificate.id, activeCourse.id);
    const { courseId, contentId, moduleId, clrId } = res.data;

    if (moduleId && contentId) {
      openContentPlayer(
        courseId,
        contentId,
        `/certificates/${certificate.id}`,
        null,
        true,
        clrId,
        null
      );
    } else {
      showToast('No content available for this course', 'error');
    }
  } catch (err) {
    console.error(err);
    showToast('Could not start certificate', 'error');
  }
};

// const handleStart = async (course) => {
//   try {
//     if (!course) {
//       showToast('No course linked with this certificate', 'error');
//       return;
//     }
// if (!course?.id) {
//   console.error("Course ID is missing!");
//   return;
// }
//     const res = await certificateService.startCertificate(certificate.id, course.id);
//     const { courseId, contentId, moduleId, clrId } = res.data;

//     if (moduleId && contentId) {
//       openContentPlayer(
//         courseId,
//         contentId,
//         `/certificates/${certificate.id}`,
//         true,
//         clrId,
//         null,
//       );
//     } else {
//       showToast('No content available for this course', 'error');
//     }
//   } catch (err) {
//     console.error(err);
//     showToast('Could not start certificate', 'error');
//   }
// };
// const handleContinueLearning = async () => {
//   try {
//     const res = await certificateService.getNextCourseAndContent(certificate.id); 
//     const { courseId, contentId, moduleId, clrId } = res.data;

//     if (moduleId && contentId) {
//       openContentPlayer(
//         courseId,
//         contentId,
//         `/certificates/${certificate.id}`,
//         true,
//         clrId,
//         null
//       );
//     } else {
//       showToast("No content available to continue", "error");
//     }
//   } catch (err) {
//     console.error(err);
//     showToast("Could not continue learning", "error");
//   }
// };



 const handleActivityClick = (courseId, content) => { 
    if (isAdminOrAuthor || enrolled) {
      const refId = content.ref_id || content.ccr_id || content.id;
      const clrId = content.clr_id || null;
      openContentPlayer(courseId, refId, `/certificates/preview/${id}`, clrId);
    }
    else {
      showToast("Enrollment required to access content", "warning");
      return;
    }
  };

  return (
    
    <Box >
      {/* Header */}
      
       <HeaderPaper elevation={0} className="header-paper">
      <Box className="header-gradient">
      <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} md={8}>
        <Typography variant="h3" component="h1" className="course-title" fontWeight="bold">
          {certificate.name}
        </Typography>
        <Typography className="course-title">
          Certificate
          </Typography>

          </Grid>
          </Grid>
      </Box>
     </HeaderPaper>

      {/* Content */}
      <Grid container spacing={3} sx={{ mt: 2, px: 3 }}>
        {/* Left */}
        <Grid item xs={12} md={8}>
         <SectionPaper elevation={0}>
               <Typography variant="h5" component="h2" gutterBottom>
                 About This Certificate
               </Typography>
               <Divider sx={{ mb: 2 }} />
               
               <DescriptionContent 
                 dangerouslySetInnerHTML={{ __html: certificate.description || 'No description available.' }} 
               />
             </SectionPaper>
        <Box>
      {courses.length === 0 ? (
        <Typography>No courses linked to this certificate.</Typography>
      ) : (
        <Box>
          <Typography variant="subtitle1" fontWeight={600} color="text.secondary" mb={1}>Core Content</Typography>
           
          <Stack spacing={2}>

  {courses.map((course) => {
  const coverImage = course.cover_picture
    ? `/uploads/courses/${course.cover_picture}`
    : `/assets/images/course-default.jpg`;

  const contents = courseContents[course.id] || [];
  const isExpanded = expandedCourseId === course.id;

  return (
    <Paper key={course.id} elevation={1} className="prerequisite-card">
    <AccordionSummary 
    // onClick={() => handleCourseToggle(course.id)}
    //                  expandIcon={<ExpandMore />}
                     className="content-accordion-summary"
                    sx={{
                      minHeight: '80px',
                    }}
                  >
                  
    <ContentThumbnail>
      <Box className="card-image-wrapper">
        <img
          src={coverImage}
          alt={course.name}
          className="content-thumbnail-img"
          sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover'
              }}
          onError={(e) => {
          e.currentTarget.onerror = null;
          e.currentTarget.src = '/assets/images/course-default.jpg';
          }}
        />
      </Box>
</ContentThumbnail>
      <Box className="card-content" p={1} >
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="subtitle1" className="card-title">
              {course.name}
            </Typography>
                        <Typography variant="caption"
                        sx={{
                          color: '#1976d2', 
                          fontWeight: 500,
                          display: 'inline-block',
                          border: `1px solid #1976d2`,
                          borderRadius: '8px',
                          padding: '0 6px',
                          marginTop: '4px',
                          lineHeight: '20px', 
                          textAlign: 'center',
                          height: '22px', 
                          minWidth: '50px' 
                        }}
                      >
                        Course
                      </Typography>
          </Box>

          <IconButton onClick={() => handleCourseToggle(course.id)}>
            {isExpanded ? <ExpandMore /> : <ArrowForward />}
          </IconButton>
        </Box>

        {/* Expandable content list */}
        <List sx={{ width: '100%',mt: 0.5 }}>
        {isExpanded && contents.length > 0 && (
          <Box mt={2}>
            {contents.map((content) => (
              <Box
                key={content.ccr_id}
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  py: 0.5,
                  borderBottom: '1px solid #eee',
                }}
              >
              <ModuleItem 
              button
              onClick={() => handleActivityClick(course.id, content)}
              sx={{ py: 1.5 }}>
             
                <ListItemIcon>
                {getContentIcon(content.source_type)}
                </ListItemIcon>
                <ListItemText primary={content.name || content.title}
                secondary={`${(content.source_type || 'Content').charAt(0).toUpperCase() + (content.source_type || 'Content').slice(1)}`}
                
                />
                </ModuleItem>
              </Box>
            ))}
          </Box>
        )}
        </List>
      </Box>
      </AccordionSummary>
    </Paper>
  );
})}

</Stack>
        </Box>
      )}
    </Box>
        </Grid>
        
        {/* Right side */}
        <Grid item xs={12} md={4}>
         {/* Final Action Button */}
<Box sx={{ textAlign: 'center', mt: 2, mb: 3 }}>
  {!enrolledObj ? (
    <Typography color="text.secondary" align="center">
      {/* You are not enrolled in this certificate. */}
    </Typography>
  ) : !courseProgressList?.dateStarted ? (
    <Button
      variant="contained"
      onClick={handleFirstTimeStart}
    >
      Start
    </Button>
  ) : (
  <Button variant="contained" onClick={handleButtonClick}>
  {courseProgressList?.buttonText}
</Button>

  )}
</Box>



           <Card>
  {/* Overall Progress Section */}
  {courseProgressList?.dateStarted && courseProgressList?.totalCourses > 0 && (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        mb: 3,
      }}
    >
      <Typography variant="subtitle1" gutterBottom>
        Your Progress
      </Typography>

      {/* Progress Circle */}
      <ProgressCircle>
        <CircularProgress
          variant="determinate"
          value={
            (courseProgressList.completedCourses /
              courseProgressList.totalCourses) *
            100
          }
          size={80}
          thickness={4}
          sx={{
            color:
              (courseProgressList.completedCourses /
                courseProgressList.totalCourses) *
                100 ===
              100
                ? '#4caf50'
                : '#2563eb',
          }}
        />
        <CircleLabel>
          <Typography variant="body2" color="text.secondary">
            {`${Math.round(
              (courseProgressList.completedCourses /
                courseProgressList.totalCourses) *
                100
            )}%`}
          </Typography>
        </CircleLabel>
      </ProgressCircle>

      {/* Completed Text */}
      <Typography variant="subtitle2" sx={{ mt: 2 }}>
        {courseProgressList.completedText}
      </Typography>
    </Box>
  )}

            <CardContent>  
              <Typography variant="h6" gutterBottom>
                Certificate Info
              </Typography>
              <Divider sx={{ mb: 2 }} />
             <Box className="certificate-details-right" sx={{
              p: 3,
              borderRadius: 2,
              bgcolor: "#f9f9f9",
              boxShadow: 1
            }}>
      {/* Duration */}
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <AccessTime fontSize="small" sx={{ color: '#2563eb' }} />
        <Typography variant="subtitle2">Duration to Complete</Typography>
      </Stack>
      <Typography variant="body2" mb={2}>
        {certificate.days_to_complete || '--'} days
      </Typography>

      {/* Validity */}
      <Stack direction="row" alignItems="center" spacing={1} mb={1}>
        <CalendarMonthIcon fontSize="small" sx={{ color: '#2563eb' }} />
        <Typography variant="subtitle2">Validity</Typography>
      </Stack>
      <Typography variant="body2" mb={2}>
        {certificate.validity_months ? `${certificate.validity_months} months` : '--'}
      </Typography>

      {/* Skills */}
   {skills?.length > 0 && (
  <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 2 }}>
    <TipsAndUpdatesIcon sx={{ fontSize: 20, color: '#2563eb', mt: '4px', }} />
    <Box>
      <Typography variant="body2" fontWeight={500}>
        Skills
      </Typography>
      
     <Stack direction="row" spacing={2} sx={{ mt:1.5, flexWrap: 'wrap',ml: '-27px' }}>
        {skills.map((skill) => (
          <Chip
            key={skill.id}
            label={skill.name}
            size="small"
            sx={{
              
              alignSelf: 'start', 
            
            }}
          />
        ))}
      </Stack>
    </Box>
  </Box>
)}

      {/* Auto Retire */}
     
      <Stack direction="row" alignItems="center" spacing={1} mb={1} mt={2}>
        <CalendarToday fontSize="small" sx={{ color: '#2563eb' }} />
        <Typography variant="subtitle2" sx={{mb:3}}>Auto Retire Date</Typography>
      </Stack>
      <Typography variant="body2">
        {certificate.auto_retire
          ? formatDate(certificate.auto_retire)
          : '--'}
      </Typography>

    </Box>

            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CertificatePreview;
